import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';
import { IconComponent, useApp } from '@backstage/core-plugin-api';
import { CardTitleOptions } from '../CardTitle';

const useCatalogCardIconStyles = makeStyles({
  imageIcon: {
    maxWidth: '35px',
    maxHeight: '35px',
    borderRadius: '25%',
  },
});
export const CardIcon = ({
  entity,
  options,
}: {
  entity: Entity;
  options: CardTitleOptions;
}) => {
  const classes = useCatalogCardIconStyles();
  const app = useApp();
  const iconResolver = (key?: string): IconComponent =>
    key ? app.getSystemIcon(key) ?? options?.defaultIcon : options?.defaultIcon;
  const key = entity.metadata?.icon as string;
  const image = /^(\w+:)?\/\//.test(key) ? key : null;
  const Icon = iconResolver(key);
  if (!image && !Icon) return <></>;
  return (
    <Box mr={2}>
      {image && (
        <img
          alt={`${entity?.metadata?.name} Icon`}
          src={image}
          height="32"
          width="32"
          aria-hidden="true"
          className={classes.imageIcon}
        />
      )}
      {!image && Icon && <Icon fontSize="large" />}
    </Box>
  );
};
